var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#EBEDEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 25.8V22.4444C33 22.0317 33 21.8254 32.9848 21.6514C32.8156 19.7176 31.2824 18.1844 29.3486 18.0152C29.1746 18 28.9683 18 28.5556 18H28.3333C28.1492 18 28 17.8508 28 17.6667C28 16.1939 26.8061 15 25.3333 15H22.6667C21.1939 15 20 16.1939 20 17.6667C20 17.8508 19.8508 18 19.6667 18H19.4444C19.0317 18 18.8254 18 18.6514 18.0152C16.7176 18.1844 15.1844 19.7176 15.0152 21.6514C15 21.8254 15 22.0317 15 22.4444V25.8C15 28.7998 15 30.2997 15.7639 31.3511C16.0107 31.6907 16.3093 31.9893 16.6489 32.2361C17.7003 33 19.2002 33 22.2 33H25.8C28.7998 33 30.2997 33 31.3511 32.2361C31.6907 31.9893 31.9893 31.6907 32.2361 31.3511C33 30.2997 33 28.7998 33 25.8Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25C21 23.3431 22.3431 22 24 22V22C25.6569 22 27 23.3431 27 25V25C27 26.6569 25.6569 28 24 28V28C22.3431 28 21 26.6569 21 25V25Z",
    stroke: "#555555",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdGrey);
export default __webpack_public_path__ + "static/media/id_grey.da38680ffb0cf939a4940a5c2a8fd190.svg";
export { ForwardRef as ReactComponent };